import { render, staticRenderFns } from "./expandable-list-item.vue?vue&type=template&id=fa428768&scoped=true&"
import script from "./expandable-list-item.vue?vue&type=script&lang=js&"
export * from "./expandable-list-item.vue?vue&type=script&lang=js&"
import style0 from "./expandable-list-item.vue?vue&type=style&index=0&id=fa428768&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa428768",
  null
  
)

export default component.exports